import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const bulkLoginSlice = createSlice({
  name: "bulkLoginReducer",
  initialState: { pageNo: 1, 
    pageSize: 10 ,
    searchParam: null,
    bulkLoginIsShowFilter: false,
    isAssignToMe: false,
    diallerAssignmentFilter: undefined,
    connectorId: undefined,
    loanType: undefined,
    location: undefined,
    managerHierarchy: undefined,
    isLenderDecisionErr: false,
    filterData: {
      connectorId: undefined,
      loanType: undefined,
      location: undefined,
      managerHierarchy: undefined,
    },
    filterListDetails: {}, 
    selectedFilterListDetails: {}, 
  },
  
  reducers: {
    setBulkLoginPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setBulkLoginPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setBulkLoginLeadSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
    setBulkLoginIsShowFilter: (state, action: PayloadAction<boolean>) => {
      state.bulkLoginIsShowFilter = action.payload;
    },
    setBulkLoginIsAssignToMe: (state, action: PayloadAction<boolean>) => {
      state.isAssignToMe = action.payload;
    },
    setBulkLoginDiallerAssignmentFilter: (state, action: PayloadAction<any>) => {
      state.diallerAssignmentFilter = action.payload;
    },
    setBulkLoginConnectorId: (state, action: PayloadAction<any>) => {
      state.connectorId = action.payload ? action.payload : undefined;
    },
    setBulkLoginLoanType: (state, action: PayloadAction<any>) => {
      state.loanType = action.payload ? action.payload : undefined;
    },
    setBulkLoginLocation: (state, action: PayloadAction<any>) => {
      state.location = action.payload ? action.payload : undefined;
    },
    setBulkLoginManagerHierarchy: (state, action: PayloadAction<any>) => {
      state.managerHierarchy = action.payload ? action.payload : undefined;
    },
    setBulkLoginIsLenderDecisionErr: (state, action: PayloadAction<any>) => {
      state.isLenderDecisionErr = action.payload;
    },
    setBulkLoginResetFilterData: (state) => {
      state.filterListDetails = {};
      state.selectedFilterListDetails = {};
      state.connectorId = undefined;
      state.loanType = undefined;
      state.location = undefined;
      state.managerHierarchy = undefined;
      state.filterData = {
        connectorId: state.connectorId,
        loanType: state.loanType,
        location: state.location,
        managerHierarchy: state.managerHierarchy,
      };
    },
    setBulkLoginFilterData: (state, action: PayloadAction<any>) => {
      state.filterData = action.payload;
    },
    setBulkLoginFilterListDetails: (state, action: PayloadAction<any>) => {
      state.filterListDetails[action.payload.key] = action.payload.value;
    },
    setBulkLoginSelectedFilterListDetails: (state, action: PayloadAction<any>) => {
      state.selectedFilterListDetails[action.payload.key] =
        action.payload.value;
    },
 }
});

export const {   
  setBulkLoginPageNo,
  setBulkLoginPageSize,
  setBulkLoginLeadSearchParam,  
  setBulkLoginIsShowFilter,
  setBulkLoginIsAssignToMe,
  setBulkLoginDiallerAssignmentFilter,
  setBulkLoginConnectorId,
  setBulkLoginLoanType,
  setBulkLoginLocation,
  setBulkLoginManagerHierarchy,
  setBulkLoginIsLenderDecisionErr,
  setBulkLoginResetFilterData,
  setBulkLoginFilterData,
  setBulkLoginFilterListDetails,
  setBulkLoginSelectedFilterListDetails, } = bulkLoginSlice.actions;
export default bulkLoginSlice.reducer;